import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DownloadIcon from 'components/atoms/icons/downloadIcon';
import { useDispatch } from 'react-redux';
import { downloadFileFromUrl } from 'utils';

const DownloadButton = ({ patient }) => {
  const [loading, setLoading] = useState(false);
  const {
    adminPanelPatients: { getInternalAdmissionFormFile },
  } = useDispatch();

  const downloadIafPdfReport = async () => {
    setLoading(true);
    const { profile } = patient;
    const patientGuid = profile?.guid;
    const { data, error } = await getInternalAdmissionFormFile(patientGuid);
    if (data && !error) {
      data?.forEach((url) => downloadFileFromUrl(url));
    }
    setLoading(false);
  };
  const onClick = () => {
    downloadIafPdfReport().then();
  };

  return (
    <div>
      {patient?.profile?.disabledCreateInternalAdmissionForms && (
        <button
          onClick={() => onClick()}
          type="button"
          className="internal-admission-download-button"
          disabled={loading}
        >
          <DownloadIcon /> IAF {loading ? 'Downloading...' : 'Download'}
        </button>
      )}
    </div>
  );
};
DownloadButton.propTypes = {
  patient: PropTypes.shape({
    profile: PropTypes.shape({
      guid: PropTypes.string,
      disabledCreateInternalAdmissionForms: PropTypes.bool,
    }),
  }),
};

export default DownloadButton;
